"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.useClient = exports.useFlags = exports.setup = exports.withFeatureFlags = void 0;
var withFeatureFlags_1 = require("./withFeatureFlags");
__createBinding(exports, withFeatureFlags_1, "default", "withFeatureFlags");
var setup_1 = require("./setup");
__createBinding(exports, setup_1, "default", "setup");
var useFlags_1 = require("./useFlags");
__createBinding(exports, useFlags_1, "default", "useFlags");
var useClient_1 = require("./useClient");
__createBinding(exports, useClient_1, "default", "useClient");
//# sourceMappingURL=index.js.map